module.exports = __webpack_public_path__ + "static/media/switch-to-full-screen-button.f54fbffc.svg";